import { SimpleTextFormat } from '@/components/element/SimpleTextFormat';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  modalId: string;
  message: string;
  messageLink?: {
    url: string;
    label: string;
  };
  showModalButtonRef: React.RefObject<HTMLButtonElement>;
};

export const ModalMessage = ({ modalId, message, messageLink, showModalButtonRef }: Props) => {
  return (
    <div>
      <button
        type="button"
        className="btn bg-gradient-primary"
        data-bs-toggle="modal"
        data-bs-target="#messageModal"
        style={{ display: 'none' }}
        ref={showModalButtonRef}
      ></button>

      <div className="modal fade" id={modalId} tabIndex={-1} role="dialog" aria-labelledby={modalId} aria-hidden="true">
        <div className="modal-dialog modal-danger modal-dialog-centered modal-" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="modal-title-notification">
                Confirmation
              </h6>
              <button type="button" className="btn-close text-dark" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <i className="fas fa-exclamation-circle ni-3x badge-warning bg-transparent"></i>
                <p className="mt-4 text-sm">
                  <SimpleTextFormat content={message} />
                </p>
                {messageLink && (
                  <p className="mt-4 text-sm">
                    <Link
                      to={messageLink.url}
                      onClick={() => {
                        showModalButtonRef?.current?.click();
                      }}
                      className="text-decoration-underline"
                    >
                      {messageLink.label}
                    </Link>
                  </p>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn bg-gradient-secondary btn-sm" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
